import React, {Component} from 'react';
import TableHolderCustom from '../visualization/table-holder-custom';
import Spinner from '../generic/spinner';
import Parse from 'parse';
import moment from 'moment-timezone';
import DateRangePickerFilter from '../visualization/date-range2';
import Utils from "../../Utils/Utility";
import Api from "../../Utils/api";
import Modal from "../generic/modal";

const columns = {
    // 'orderType'        : {type : 'string',label : 'Order Type'},
    'chargeTag'        : {type : 'string',label : 'Charge Tag'},
    'chargeType'        : {type : 'string',label : 'Charge Type'},
    'orderCount'       : {type : 'string',label : 'Orders'},
    // 'itemsToPrep'      : {type : 'string',label : 'Item Count'},
    'chargeFee'        : {type : 'number',label : 'Total', prefix: '$'},
    'chargeTax'        : {type : 'number',label : 'Tax', prefix: '$'},
    // 'totalAmount'      : {type : 'number',label : 'Total', prefix: '$'},
    // 'subTotal'         : {type : 'number',label : 'Sub-Total', prefix: '$'},
    // 'taxes'            : {type : 'number',label : 'Taxes', prefix: '$'},
    // 'tipAmount'        : {type : 'number',label : 'Tip', prefix: '$'},
    // 'serviceFee'       : {type : 'number',label : 'Service Fee', prefix: '$'},
    // 'deliveryFee'      : {type : 'number',label : 'Delivery Fee', prefix: '$'},
    // 'platformCharge'   : {type : 'number',label : 'Platform Charge', prefix: '$'}
};

var orderTypeColumns = {
    'orderType'        : {type : 'string',label : 'Order Type'},
    // 'chargeTag'        : {type : 'string',label : 'Charge Tag'},
    'orderCount'       : {type : 'string',label : 'Orders'},
    // 'itemsToPrep'      : {type : 'string',label : 'Item Count'},
    'chargeFee'        : {type : 'number',label : 'Total', prefix: '$'},
    'chargeTax'        : {type : 'number',label : 'Tax', prefix: '$'},
    // 'totalAmount'      : {type : 'number',label : 'Total', prefix: '$'},
    // 'subTotal'         : {type : 'number',label : 'Sub-Total', prefix: '$'},
    // 'taxes'            : {type : 'number',label : 'Taxes', prefix: '$'},
    // 'tipAmount'        : {type : 'number',label : 'Tip', prefix: '$'},
    // 'serviceFee'       : {type : 'number',label : 'Service Fee', prefix: '$'},
    // 'deliveryFee'      : {type : 'number',label : 'Delivery Fee', prefix: '$'},
    // 'platformCharge'   : {type : 'number',label : 'Platform Charge', prefix: '$'}
};

export default class ChargeSummaryView extends Component {

    static contextTypes = {
        router: React.PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            chargesData      : [],
            isLoaded       : true,
            isLoadedModal   : true,
            activeLocation : '',
            fromDate       : this.setLocationTimeZoneInMoment(),
            toDate         : this.setLocationTimeZoneInMoment(),
            timeZone       : '',
            totalOrderCount: 0,
            showChargesSummary: false,
            showChargeDetailModal : false,
            totalChargeOrderCount: 0,
            orderTypeChargesData : [],
            chargeTag:'',
            chargeType:'',
            groupByField:'chargeOption'
        };

        this._bind(
            'initializeDateTime',
            'fetchOrderDetails',
            'onDateSelectionChanged',
            'handleChange',
            'setLocationTimeZoneInMoment'
        );
    }

    _bind(...methods) {
        methods.forEach((method) => this[method] = this[method].bind(this));
    }

    /*  Set default timezone on moment  */
    setLocationTimeZoneInMoment(){

        let timeZone = Utils.extractTimeZoneFromLocation(this.props.activeLocation);
        moment.tz.setDefault(timeZone);
        return moment();
    }

    handleChange(field, e){

        let errors = {};
        this.setState({
            errors: errors
        });

        // let groupByField = this.state.groupByField;
        var value = e.target.value;

        // fields[field] = value;
        this.setState({
            groupByField : value
        },()=>{
            this.loadModalPopup(this.state.chargeTag, this.state.chargeType, this.state.groupByField);
        });


    }

    initializeDateTime(){

        let self = this;

        let timeZone = this.state.timeZone;

        let currentDateTime = Utils.formatDateTimeWithTimeZone(new Date(), timeZone);

        let defaultFromDate = new Date(currentDateTime);
        let defaultToDate = new Date(currentDateTime);

        defaultFromDate.setDate(defaultFromDate.getDate() - 0);
        defaultFromDate.setHours(0, 0, 0, 0);

        defaultToDate.setHours(23, 59, 59, 0);

        this.setState({
            chargesData      : [],
            fromDate       : defaultFromDate,
            toDate         : defaultToDate,
            totalOrderCount: 0,
            showChargesSummary : true
        },()=>{

            Utils.isUserSessionInvalid().then((response) => {
                self.fetchOrderDetails();
            }, (error) => {
                // console.log("error user session: "+JSON.stringify(error));
                // user session is invalid
                Utils.checkErrorIsInvalidSessionToken(error, self.context.router);

            });

        });

    }

    componentDidMount() {

        let self = this;
        self.initializeDateTime();
    }

    onDateSelectionChanged(fromDate, toDate) {

        this.setState({
            fromDate, toDate,
            isLoaded: false,
            chargesData:[],
            totalOrderCount : 0
        }, () => {
            this.fetchOrderDetails();
        });
    }

    fetchOrderDetails() {

        if (!this.state.activeLocation) {
            return;
        }

        let self = this;
        self.setState({
            isLoaded : false
        });

        let currentUser = Parse.User.current();
        let userId = currentUser.id;
        let sessionToken = currentUser.getSessionToken();
        let locId = self.state.activeLocation.objectId;

        const businessDetail = currentUser.get("bizId");
        const bizId          = businessDetail.id;

        let fromDate = self.state.fromDate;
        let toDate = self.state.toDate;

        // let fromDateTime =  moment(fromDate).format('YYYY-MM-DD');
        // let toDateTime =  moment(toDate).format('YYYY-MM-DD');

        let fromDateTime =  Utils.getDateString(fromDate, this.state.timeZone);
        let toDateTime =  Utils.getDateString(toDate, this.state.timeZone);

        const dateRange = {'tzStartDate': fromDateTime, 'tzEndDate': toDateTime};

        let params = {
            bizId       : bizId,
            locId       : locId,
            dateRange   : dateRange
        };

        Api.getChargeSummary(
            userId, sessionToken, params
        ).then((response) => {
                self.parseOrderData(response);
            },
            (error) => {
                Utils.checkErrorIsInvalidSessionToken(error, self.context.router);
            });

    }

    parseOrderData(orderResponseData){

        let self = this;
        if (orderResponseData.data && orderResponseData.data.length > 0) {
            const results = orderResponseData.data;

            results.forEach(result => {

                /* Response Data*/
                let newTable = {};
                Object.keys(columns).forEach(col => {

                    if (col === "totalAmount") {
                        newTable[col] = Utils.number2digit(result["totalAmount"]);
                    }
                    else if (col === "subTotal") {
                        newTable[col] = Utils.number2digit(result["subTotal"]);
                    } else if (col === "chargeFee") {
                        newTable[col] = Utils.number2digit(result["chargeFee"]);
                    } else if (col === "chargeTax") {
                        newTable[col] = Utils.number2digit(result["chargeTax"]);
                    }
                    else if (col === "platformCharge") {
                        newTable[col] = Utils.number2digit(result["platformCharge"]);
                    }
                    else if (col === "taxes") {
                        newTable[col] = Utils.number2digit(result["taxes"]);
                    } else if (col === "tipAmount") {
                        newTable[col] = Utils.number2digit(result["tipAmount"]);
                    }else if (col === "serviceFee") {
                        newTable[col] = Utils.number2digit(result["serviceFee"]);
                    }else if (col === "deliveryFee") {
                        newTable[col] = Utils.number2digit(result["deliveryFee"]);
                    }else if (col === "chargeType") {
                        newTable[col] = Utils.getChargeFullName(result["chargeType"]);
                    }
                    else if (col === "chargeTag") {
                        if (!Utils.isEmptyObj(result["objectId"])){
                            let tagName = result["objectId"];
                            // console.log(result["objectId"]["chargeTag"]);
                            // newTable[col] = result["orderType"];
                            newTable[col] = tagName ? tagName : null;
                        }
                        else {
                            newTable[col] = null;
                        }
                    }
                    else {
                        newTable[col] = result[col];
                    }
                });

                self.state.chargesData.push(newTable);

            });

            this.setState({
                isLoaded: true,
                totalOrderCount: results.length
            });

        }
        else {
            self.setState({
                isLoaded: true
            });
        }

    }

    componentWillMount() {

        let timeZone = Utils.extractTimeZoneFromLocation(this.props.activeLocation);

        let self = this;
        self.setState({
            activeLocation: this.props.activeLocation,
            timeZone: timeZone
        });
    }

    componentWillReceiveProps(nextProps) {
        let currentActiveLoc = this.props.activeLocation;
        let locId = "";

        if (currentActiveLoc) {
            locId = currentActiveLoc.objectId;
        }

        if (nextProps !== null
            &&
            nextProps.activeLocation !== null
            &&
            nextProps.activeLocation.objectId !== locId
        ) {
            this.setState({
                    activeLocation: nextProps.activeLocation,
                    timeZone: Utils.extractTimeZoneFromLocation(nextProps.activeLocation),
                    chargesData: [],
                    totalOrderCount: 0,
                },
                () => {
                    this.initializeDateTime();
                });
        }
    }

    loadModalPopup(chargeTag, chargeType, filterGroup = false) {

        if (!this.state.activeLocation) {
            return;
        }

        let grpByField = "chargeOption";
        if (!Utils.isEmpty(filterGroup) && filterGroup !== false){
            grpByField = filterGroup;
        }

        let self = this;
        self.setState({
            chargeTag:chargeTag,
            chargeType:chargeType,
            isLoaded : false,
            isLoadedModal : false,
            orderTypeChargesData:[],
            totalChargeOrderCount:0,
            groupByField : grpByField
        });

        let currentUser = Parse.User.current();
        let userId = currentUser.id;
        let sessionToken = currentUser.getSessionToken();
        let locId = self.state.activeLocation.objectId;

        const businessDetail = currentUser.get("bizId");
        const bizId          = businessDetail.id;

        let fromDate = self.state.fromDate;
        let toDate = self.state.toDate;

        // let fromDateTime =  moment(fromDate).format('YYYY-MM-DD');
        // let toDateTime =  moment(toDate).format('YYYY-MM-DD');

        let fromDateTime =  Utils.getDateString(fromDate, this.state.timeZone);
        let toDateTime =  Utils.getDateString(toDate, this.state.timeZone);

        const dateRange = {'tzStartDate': fromDateTime, 'tzEndDate': toDateTime};


        let params = {
            bizId       : bizId,
            locId       : locId,
            dateRange   : dateRange,
            chargeTag   : chargeTag,
            groupByField   : grpByField,
        };

        Api.getChargeSummary(
            userId, sessionToken, params
        ).then((response) => {

                // console.log(JSON.stringify(response));

                // let responseData = {"data":[{"serviceFee":3.88,"totalAmount":298.39,"itemsToPrep":20,"chargeFee":21.85,"deliveryFee":15,"tipAmount":38.8,"chargeTax":0,"orderCount":3,"taxes":19.86,"subTotal":194,"objectId":"Tip","platformCharge":0},{"serviceFee":8.2,"totalAmount":605,"itemsToPrep":36,"chargeFee":3.2,"deliveryFee":25,"tipAmount":67,"chargeTax":0,"orderCount":7,"taxes":43.16,"subTotal":410,"objectId":"For Charity","platformCharge":0},{"serviceFee":13.1,"totalAmount":950.55,"itemsToPrep":57,"chargeFee":27.59,"deliveryFee":40,"tipAmount":99.9,"chargeTax":2.63,"orderCount":10,"taxes":68.66,"subTotal":655,"objectId":"Homeless People","platformCharge":0},{"serviceFee":13.1,"totalAmount":950.55,"itemsToPrep":57,"chargeFee":43.1,"deliveryFee":40,"tipAmount":99.9,"chargeTax":0,"orderCount":10,"taxes":68.66,"subTotal":655,"objectId":"Fixed Charge for staff","platformCharge":0},{"serviceFee":0.98,"totalAmount":79.81,"itemsToPrep":7,"chargeFee":5,"deliveryFee":5,"tipAmount":9.8,"chargeTax":0,"orderCount":1,"taxes":5.13,"subTotal":49,"objectId":"delivery gratuity","platformCharge":0}],"functionName":"getChargeSummary","hasMore":false,"uri":"/Order"}

                self.parseChargeOrderTypeData(response);
            },
            (error) => {
                Utils.checkErrorIsInvalidSessionToken(error, self.context.router);
            });

    }

    parseChargeOrderTypeData(orderResponseData){

        let self = this;
        if (orderResponseData.data && orderResponseData.data.length > 0) {
            const results = orderResponseData.data;

            results.forEach(result => {

                /* Response Data*/
                let newTable = {};
                Object.keys(orderTypeColumns).forEach(col => {

                    if (col === "totalAmount") {
                        newTable[col] = Utils.number2digit(result["totalAmount"]);
                    }
                    else if (col === "subTotal") {
                        newTable[col] = Utils.number2digit(result["subTotal"]);
                    } else if (col === "chargeFee") {
                        newTable[col] = Utils.number2digit(result["chargeFee"]);
                    } else if (col === "chargeTax") {
                        newTable[col] = Utils.number2digit(result["chargeTax"]);
                    }
                    else if (col === "platformCharge") {
                        newTable[col] = Utils.number2digit(result["platformCharge"]);
                    }
                    else if (col === "taxes") {
                        newTable[col] = Utils.number2digit(result["taxes"]);
                    } else if (col === "tipAmount") {
                        newTable[col] = Utils.number2digit(result["tipAmount"]);
                    }else if (col === "serviceFee") {
                        newTable[col] = Utils.number2digit(result["serviceFee"]);
                    }else if (col === "deliveryFee") {
                        newTable[col] = Utils.number2digit(result["deliveryFee"]);
                    }
                    else if (col === "orderType") {
                        if (!Utils.isEmptyObj(result["objectId"])){
                            let tagName = result["objectId"];
                            // console.log(result["objectId"]["chargeTag"]);
                            // newTable[col] = result["orderType"];
                            newTable[col] = tagName ? tagName : null;
                        }
                        else {
                            newTable[col] = null;
                        }
                    }
                    else {
                        newTable[col] = result[col];
                    }
                });

                self.state.orderTypeChargesData.push(newTable);

            });

            self.setState({
                isLoaded: true,
                isLoadedModal: true,
                totalChargeOrderCount: results.length
            },()=>{
                self.showChargeDetailModal();
                });

        }
        else {
            self.setState({
                isLoaded: true,
                isLoadedModal: true
            });
        }

    }


    showChargeDetailModal = () => {
        // disable the body scroll
        $("body").css('overflow', 'hidden');
        this.setState({
            showChargeDetailModal: true
        });
    }
    hideChargeDetailModal = () => {
        // enable the body scroll
        $("body").css('overflow', 'auto');
        this.setState({
            showChargeDetailModal: false
        });
    }

    loadOrderTypeAndChargeOptionFilter(){

        let chargeType = this.state.chargeType;

        // check charge type Optional
        // Filter will be shown only for Optional charge
        if (chargeType !== "Optional"){
            return
        }

        return ( <div className="col-lg-12 orderTypeOption">
            <div className="form-group">
                <h4>Filter Charge summary grouped by charge options or order type :</h4>
                <div
                    onChange={this.handleChange.bind(this, "groupByField")}>
                    <label className="radio-inline">
                        <input type="radio" name="taxable"
                               id="groupByField2"
                               value="chargeOption"
                               checked={this.state.groupByField === 'chargeOption'}
                               onChange={()=>{}}/> Charge Option
                    </label>
                    <label className="radio-inline">
                        <input type="radio" name="taxable"
                               id="groupByField1"
                               value="orderType"
                               checked={this.state.groupByField === 'orderType'}
                               onChange={()=>{}}/> Order Type
                    </label>
                </div>
            </div>
        </div>);
    }

    render() {

        // set custom button in the table column
        columns["chargeTag"] = {
            ...columns.chargeTag,
            Cell: rowVal => {



                if (rowVal.chargeType === "Optional"){

                    return (<button style={{cursor:'pointer'}} onClick={_ => this.loadModalPopup(rowVal.chargeTag, rowVal.chargeType)} type="button" className="btn1 btn-link">{rowVal.chargeTag}</button>)

                }
                else{

                    return (rowVal.chargeTag)

                }
            }
        };

        let chargeTag = this.state.chargeTag;

        let chargeTagTitle = "Tag '"+chargeTag+"' Report";

        let groupByField = this.state.groupByField;


        if (groupByField === "chargeOption"){
            orderTypeColumns.orderType.label = "Charge Option";
        }
        else {
            orderTypeColumns.orderType.label = "Order Type";
        }

        return (
            <div className="order-pg">
                {!this.state.isLoaded ? <Spinner/> : null}
                {
                    this.state.showChargeDetailModal ? <Modal
                        show={this.state.showChargeDetailModal}
                        closeCallback={this.hideChargeDetailModal}
                        customClass="custom_modal_class"
                        headerCustomClass={"modal-header-custom charge-summary-text"}
                        title={chargeTagTitle}
                    >
                        {!this.state.isLoadedModal ? <Spinner/> : null}
                        <div className={"charge-summary-container"}>

                            {
                                this.loadOrderTypeAndChargeOptionFilter()
                            }

                            {
                                this.state.totalChargeOrderCount > 0 ?
                                    <TableHolderCustom
                                        columns={orderTypeColumns}
                                        tableData={this.state.orderTypeChargesData}
                                        isPrevBtnActive={'disabled'}
                                        isNextBtnActive={'disabled'}
                                        countDefault={0}
                                        customClass={"custom-charge-table"}
                                        // pagination={this.state.pagination}
                                    /> :
                                    <div className="col-md-12 text-center header-summary ">
                                        <h4 className="h-small">No record found
                                        </h4>
                                    </div>
                            }

                        </div>
                    </Modal> : null
                }
                {
                    this.state.showChargesSummary ? (
                        <div>

                            <div className = "col-md-12 order-container-pg">
                                {/*<div className="col-md-12">*/}

                                {/*</div>*/}
                                <div className="row">
                                    <div className={"col-md-12 no-gutter ml-10"}>
                                        <DateRangePickerFilter
                                            className={"datepicker-container"}
                                            fromMessage={"Select date range"}
                                            defaultDateRangeDays={"730"}
                                            startDefaultFromDays={"0"}
                                            allowMinPastYear={"3"}
                                            timeZone = {this.state.timeZone}
                                            callBackParent={this.onDateSelectionChanged}
                                        />

                                        <div className="col-md-3"></div>
                                    </div>
                                </div>

                            </div>

                            <div className="col-md-12 text-center">
                                <h3 className="h-small-new"><b>Charge summary
                                    from {Utils.getDateString(this.state.fromDate, this.state.timeZone)} to {Utils.getDateString(this.state.toDate, this.state.timeZone)}
                                </b>
                                </h3>
                            </div>

                            <div className="col-md-12">
                                {
                                    this.state.totalOrderCount > 0 ?
                                        <TableHolderCustom
                                            columns={columns}
                                            tableData={this.state.chargesData}
                                            isPrevBtnActive={'disabled'}
                                            isNextBtnActive={'disabled'}
                                            countDefault={0}
                                            // pagination={this.state.pagination}
                                        /> :
                                        <div className="col-md-12 text-center">
                                            <h4 className="h-small">No record found
                                            </h4>
                                        </div>
                                }
                            </div>

                        </div>
                    ) : null
                }

            </div>
        );
    }

}





// WEBPACK FOOTER //
// src/components/custom-charges/charge-summary-view.js